// Valor monetário por extenso (pt-BR). Ex.: 1250.5 → "mil duzentos e cinquenta reais e cinquenta centavos"
const UNIDADES = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove', 'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
const DEZENAS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const CENTENAS = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];
const ESCALAS = [['', ''], ['mil', 'mil'], ['milhão', 'milhões'], ['bilhão', 'bilhões']];

const ateNovecentos = (n) => {
  if (n === 0) return '';
  if (n === 100) return 'cem';
  const c = Math.floor(n / 100), r = n % 100;
  const partes = [];
  if (c) partes.push(CENTENAS[c]);
  if (r < 20) { if (r) partes.push(UNIDADES[r]); }
  else {
    const d = Math.floor(r / 10), u = r % 10;
    partes.push(u ? `${DEZENAS[d]} e ${UNIDADES[u]}` : DEZENAS[d]);
  }
  return partes.join(' e ');
};

const inteiroExtenso = (n) => {
  if (n === 0) return 'zero';
  const grupos = [];
  let i = 0;
  while (n > 0 && i < ESCALAS.length) { grupos.push(n % 1000); n = Math.floor(n / 1000); i++; }
  const partes = [];
  for (let g = grupos.length - 1; g >= 0; g--) {
    const v = grupos[g];
    if (!v) continue;
    const [sing, plur] = ESCALAS[g];
    if (g === 1 && v === 1) partes.push('mil');
    else partes.push(`${ateNovecentos(v)}${sing ? ` ${v === 1 ? sing : plur}` : ''}`);
  }
  // "e" antes do último grupo quando ele é < 100 ou múltiplo de 100 (ex.: mil e duzentos, dois mil e cinco)
  if (partes.length > 1) {
    const ultimo = grupos[0];
    if (ultimo && (ultimo < 100 || ultimo % 100 === 0)) {
      const fim = partes.pop();
      return `${partes.join(' ')} e ${fim}`;
    }
  }
  return partes.join(' ');
};

export const valorPorExtenso = (valor) => {
  const v = Math.round(Math.abs(Number(valor) || 0) * 100);
  const reais = Math.floor(v / 100), cents = v % 100;
  const partes = [];
  if (reais) {
    const de = reais >= 1000000 && reais % 1000000 === 0 ? 'de ' : '';
    partes.push(`${inteiroExtenso(reais)} ${de}${reais === 1 ? 'real' : 'reais'}`);
  }
  if (cents) partes.push(`${inteiroExtenso(cents)} ${cents === 1 ? 'centavo' : 'centavos'}`);
  if (!partes.length) return 'zero reais';
  return partes.join(' e ');
};
